namespace InvData.Models {

    export interface IdAndCodeObject {
        id: number,
        code?: string
    }

    export class IdAndCodeObjectIndex<EntryType extends IdAndCodeObject> {

        public itemList: EntryType[];
        public idToItemMap: { [id: number]: EntryType } = {};
        public codeToItemMap: { [id: string]: EntryType } = {};

        constructor(itemList?: EntryType[]) {
            this.itemList = itemList ? itemList : [];

            for (var i = 0; i < this.itemList.length; i++) {
                var item = this.itemList[i];
                this._addToIndexMaps(item);
            }
        }

        public _addToIndexMaps(item: EntryType): void {
            if (item.id) {
                this.idToItemMap[item.id] = item;
            }
            if (item.code) {
                this.codeToItemMap[item.code] = item;
            }
        }

        /**
         * tryGetById will return item with given id, or return null if not found.
         * @param id
         */
        public tryGetById(id: number): EntryType {
            var item = this.idToItemMap[id];
            return item ? item : null;
        }

        /**
         * tryGetByCode will return item with given code, or return null if not found.
         * @param code
         */
        public tryGetByCode(code: string): EntryType {
            var item = this.codeToItemMap[code];
            return item ? item : null;
        }

        public add(item: EntryType): void {
            if (!this.idToItemMap[item.id]) {
                this.itemList.push(item);
                this._addToIndexMaps(item);
            }
            else {
                throw "item id already exists in collection: " + item.id;
            }
        }

        public addOrReplace(item: EntryType): void {
            if (this.idToItemMap[item.id]) {
                this.removeById(item.id);
            }

            this.add(item);
        }

        public removeById(id: number): void {
            var item = this.tryGetById(id);
            if (item) {
                delete this.idToItemMap[item.id];

                if (item.code) {
                    delete this.codeToItemMap[item.code]
                }

                this.itemList = this.itemList.filter(function (i) { return i.id != item.id; });
            }
        }
    }

}   
